"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.INITIAL_STATE = void 0;

var _reduxActions = require("redux-actions");

var _constants = require("../constants");

var _handleActions;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INITIAL_STATE = {
  hoveredAnnotation: null,
  touchPressed: false
};
/**
 * Reducer to handle saving a hovered annotation ID
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */

exports.INITIAL_STATE = INITIAL_STATE;

var annotationSetHoveredAnnotation = function annotationSetHoveredAnnotation(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    hoveredAnnotation: action.annotationId
  });
};
/**
 * Reducer to handle saving a hovered annotation ID
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var annotationSetDrawingNode = function annotationSetDrawingNode(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    drawingNode: action.drawingNode
  });
};
/**
 * Reducer to handle setting touch pressed
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var annotationSetTouchPressed = function annotationSetTouchPressed(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    touchPressed: action.touchPressed
  });
};
/**
 * Reducer to handle setting selected annotation
 * @param {object} state - current state of store
 * @param {object} action - action sent to the reducer
 * @returns {undefined}
 */


var annotationSetSelectedAnnotationId = function annotationSetSelectedAnnotationId(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedAnnotationId: action.selectedAnnotationId
  });
};

var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.ANNOTATION_SET_HOVERED_ANNOTATION, annotationSetHoveredAnnotation), _defineProperty(_handleActions, _constants.ANNOTATION_SET_DRAWING_NODE, annotationSetDrawingNode), _defineProperty(_handleActions, _constants.ANNOTATION_SET_TOUCH_PRESSED, annotationSetTouchPressed), _defineProperty(_handleActions, _constants.ANNOTATION_SET_SELECTED_ANNOTATION_ID, annotationSetSelectedAnnotationId), _handleActions), INITIAL_STATE);

exports.default = _default;